<template>
  <div class="home">
    <big-picture></big-picture>
    <mt-basics></mt-basics>
    <we-service></we-service>
    <product-system></product-system>
    <we-advantage></we-advantage>
    <home-new></home-new>
    <cooperative-partner></cooperative-partner>
  </div>
</template>

<script>
import BigPicture from "../home/big-picture.vue";
import MtBasics from "../home/mt-basics.vue";
import WeService from "../home/we-service.vue";
import ProductSystem from "../home/product-system.vue";
import WeAdvantage from "../home/we-advantage.vue";
import HomeNew from "../home/home-new.vue";
import CooperativePartner from "../home/cooperative-partner.vue";
export default {
  name: "home",
  components: {
    BigPicture,
    MtBasics,
    WeService,
    ProductSystem,
    WeAdvantage,
    HomeNew,
    CooperativePartner,
  },
  methods: {
    // getEquipment() {
    //   let equ = navigator.userAgent.match(
    //     /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    //   );
    //   console.log(equ);
      
    // }
  },
};
</script>

<style scoped lang="scss">
.home {
  background-color: #fff;
}
</style>
